const animatedElements = document.querySelectorAll('.scroll-animated, .scroll-fade');

const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
            if (entry.target.classList.contains('scroll-animated')) {
                entry.target.classList.add('animate__animated', 'animate__fadeInUp', 'animate__slow');
            } else if (entry.target.classList.contains('scroll-fade')) {
                entry.target.classList.add('animate__animated', 'animate__fadeInDown','animate__slow');
            }


            observer.unobserve(entry.target); // Stop observing after animation has been applied
        }
    });
});

animatedElements.forEach((element) => {
    observer.observe(element);
});
